var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        viewBox: "0 0 372 145",
        fill: _vm.fill,
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M25.3101 5.34014H16V33.2101H10.5699V5.34014H1.21997V0.140137H25.3101V5.34014Z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M58.28 26.5501H44.2L41.89 33.2101H35.98L47.98 0.140137H54.5L66.45 33.2101H60.59L58.28 26.5501ZM56.49 21.4501L51.25 6.52014L46 21.4501H56.49Z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M100.99 28.0101V33.2101H82.0898V0.140137H87.5199V28.0101H100.99Z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M137.17 28.0101V33.2101H117.09V0.140137H136.93V5.34014H122.52V13.9401H135.75V19.0901H122.52V28.0201H137.17V28.0101Z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M179.5 0.140137V33.2101H175.25L159.66 10.7701V33.2101H154.23V0.140137H158.48L174.07 22.5801V0.140137H179.5Z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M219.7 5.34014H210.39V33.2101H204.96V5.34014H195.61V0.140137H219.7V5.34014Z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M23.04 81.7601H8.95996L6.65002 88.4201H0.73999L12.74 55.3501H19.26L31.21 88.4201H25.35L23.04 81.7601ZM21.25 76.6601L16 61.7301L10.76 76.6601H21.25Z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M43.97 71.8902C43.97 62.3002 51.2 54.7402 61.26 54.7402C67.31 54.7402 72.69 57.8102 75.48 62.6302L70.76 65.3702C69.01 62.1102 65.42 60.0302 61.26 60.0302C54.13 60.0302 49.4 65.0902 49.4 71.8902C49.4 78.6902 54.12 83.7502 61.26 83.7502C65.42 83.7502 69.05 81.6702 70.76 78.4102L75.48 81.1002C72.74 85.9202 67.36 89.0402 61.26 89.0402C51.2 89.0402 43.97 81.4802 43.97 71.8902Z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M113.32 60.5501H104.01V88.4201H98.58V60.5501H89.23V55.3501H113.32V60.5501Z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: { d: "M134.86 55.3501V88.4201H129.43V55.3501H134.86Z" },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M150.49 55.3501H156.44L165.23 81.8501L174.06 55.3501H179.97L168.49 88.4201H161.97L150.49 55.3501Z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M212.94 81.7601H198.86L196.55 88.4201H190.64L202.64 55.3501H209.16L221.11 88.4201H215.25L212.94 81.7601ZM211.15 76.6601L205.91 61.7301L200.67 76.6601H211.15Z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M255.88 60.5501H246.57V88.4201H241.14V60.5501H231.79V55.3501H255.88V60.5501Z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: { d: "M277.42 55.3501V88.4201H271.99V55.3501H277.42Z" },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M294.47 71.8902C294.47 62.3002 302.08 54.7402 311.62 54.7402C321.21 54.7402 328.77 62.3002 328.77 71.8902C328.77 81.4802 321.21 89.0402 311.62 89.0402C302.08 89.0402 294.47 81.4802 294.47 71.8902ZM323.34 71.8902C323.34 65.0902 318.24 60.0302 311.62 60.0302C305.01 60.0302 299.9 65.0902 299.9 71.8902C299.9 78.6902 305 83.7502 311.62 83.7502C318.24 83.7402 323.34 78.6902 323.34 71.8902Z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M371.1 55.3501V88.4201H366.85L351.26 65.9801V88.4201H345.83V55.3501H350.08L365.67 77.7901V55.3501H371.1Z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M26.96 121.43C26.96 127.52 22.24 132.3 16 132.3H9.23999V143.64H3.81006V110.57H16C22.24 110.56 26.96 115.29 26.96 121.43ZM21.53 121.43C21.53 118.08 19.21 115.67 16 115.67H9.23999V127.2H16C19.22 127.19 21.53 124.73 21.53 121.43Z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M62.6801 138.43V143.63H43.78V110.56H49.21V138.43H62.6801Z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M98.9601 136.97H84.8801L82.5701 143.63H76.6602L88.6602 110.56H95.1802L107.13 143.63H101.27L98.9601 136.97ZM97.1602 131.87L91.9202 116.94L86.6802 131.87H97.1602Z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M141.89 115.76H132.58V143.63H127.15V115.76H117.8V110.56H141.89V115.76Z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M163.43 115.76V125.02H176.89V130.22H163.43V143.64H158V110.57H177.37V115.77H163.43V115.76Z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M192.91 127.1C192.91 117.51 200.52 109.95 210.06 109.95C219.65 109.95 227.21 117.51 227.21 127.1C227.21 136.69 219.65 144.25 210.06 144.25C200.52 144.25 192.91 136.69 192.91 127.1ZM221.77 127.1C221.77 120.3 216.67 115.24 210.05 115.24C203.44 115.24 198.33 120.29 198.33 127.1C198.33 133.91 203.43 138.96 210.05 138.96C216.67 138.95 221.77 133.9 221.77 127.1Z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M256.12 131.58H249.7V143.63H244.27V110.56H257.5C263.41 110.56 268.13 115.28 268.13 121.19C268.13 125.44 265.44 129.22 261.56 130.78L269.07 143.63H263.12L256.12 131.58ZM249.69 126.72H257.48C260.36 126.72 262.68 124.26 262.68 121.19C262.68 118.07 260.37 115.66 257.48 115.66H249.69V126.72Z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M311.53 143.63V120.06L301.47 136.69H300.81L290.75 120.01V143.63H285.32V110.56H291.18L301.15 127.09L311.16 110.56H316.97V143.63H311.53Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }